<template>
  <div class="p-relative tendermint-tx-wrapper">
    <component
      :is="$route.query.type"
      v-if="currentProject"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Stake from "./Stake.vue";
import Unstake from "./Unstake.vue";
import Redelegate from "./Redelegate.vue";
import Claim from "./Claim.vue";
import EnableRestake from "./EnableRestake.vue";
import DisableRestake from "./DisableRestake.vue";
import GrantLpAutocompound from "./GrantLpAutocompound.vue";
import RevokeLpAutocompound from "./RevokeLpAutocompound.vue";
import Migrate from "./Migrate/index.vue"

const components = {
  stake: Stake,
  unstake: Unstake,
  redelegate: Redelegate,
  claim: Claim,
  enableRestake: EnableRestake,
  disableRestake: DisableRestake,
  grantLpAutocompound: GrantLpAutocompound,
  revokeLpAutocompound: RevokeLpAutocompound,
  migrate: Migrate,
};

export default {
  components,
  computed: mapGetters({
    projects: "projectConfig/projects",
    currentProject: "projectConfig/latestProject",
    walletSelected: "userWallets/walletSelected",
  }),
  methods: {
    async setProject() {
      const projectName = this.$route.params.projectName;
      const project = this.projects.find(
        item =>
          item.implemented &&
          (item.name === projectName || item.projectName === projectName)
      );
      if (!project) return this.$router.push({ name: "Home" });
      this.$store.dispatch("projectConfig/setCurrentProject", project);
      this.$store.dispatch("stakeUtils/setProjectUtils", project.name);
    },
  },
  beforeCreate() {
    if (!components[this.$route.query.type]) {
      this.$router.replace({
        path: this.$route.path + "?action=tx&type=stake",
      });
    }
  },
  watch: {
    $route() {
      this.setProject();
    },
  },
};
</script>

<style lang="scss">
.tendermint-tx-wrapper {
  .deposit-box {
    width: 630px;
    min-height: 650px;
    border: 1px solid #7387ff;
    border-radius: 16px;
  }
}
</style>
